import * as React from 'react';

import { useRefProvider } from 'src/common/stores/contexts/ref-provider';

import { UitkCardAloha, UitkCardAlohaContentSection } from 'uitk-react-cards';
import { UitkSimpleSticky } from 'uitk-react-experimental-simple-sticky';
import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiPropertySingleOfferWrapper } from '../shared-ui/offers/single-offer-price-wrapper';

export const SingleOfferPriceWrapper: React.FunctionComponent<{}> = () => {
  const [singleOfferPrice] = useRefProvider('singleOfferPrice');

  return (
    <UitkSimpleSticky stickTo={{ top: 'twelve' }} zIndex={1}>
      <div ref={singleOfferPrice}>
        <UitkSpacing margin={{ large: { block: 'three', inlinestart: 'three' } }}>
          <UitkCardAloha overflow={true}>
            <UitkSpacing padding={{ blockstart: 'three', blockend: 'six', large: { inline: 'three' } }}>
              <UitkCardAlohaContentSection padded={false}>
                <SharedUiPropertySingleOfferWrapper />
              </UitkCardAlohaContentSection>
            </UitkSpacing>
          </UitkCardAloha>
        </UitkSpacing>
      </div>
    </UitkSimpleSticky>
  );
};
